import {
  Box,
} from "@chakra-ui/react";
import { UseFormReturn } from "react-hook-form";
import { useCallback } from "react";
import DatePickerField from "components/FormElements/Fields/DatePickerField";
import { buildISODate } from "helpers/time";
import moment from "moment";
import { GreyBlackLabel } from "components/DataDisplay/GreyBlackField";
import { longAttributeStyles } from "components/DataDisplay/styles";

interface DateSelectFieldProps {
  label: string;
  datetimeFieldName: string;
  form: UseFormReturn<any>;
  labelProps?: object;
}

export default function DateSelectField({
  form, label, datetimeFieldName, labelProps = {}, ...rest
}: DateSelectFieldProps) {
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = form;
  const timezoneFieldName = "timezone";
  const dateFieldName = `local.${datetimeFieldName}.date`;
  const timeFieldName = `local.${datetimeFieldName}.timeOfDay`;

  const handleDateChange = useCallback(
    (newDate: Date | undefined) => {
      if (newDate) {
        const [time, timezone] = getValues([timeFieldName, timezoneFieldName]);
        const newIsoDate = buildISODate(newDate, time || "09:00", timezone || "UTC");
        setValue(datetimeFieldName, new Date(newIsoDate), { shouldDirty: true });
        setValue(dateFieldName, new Date(newDate), { shouldDirty: true });
      }
    },
    [dateFieldName, datetimeFieldName, getValues, setValue, timeFieldName],
  );

  return (
    <Box h="32px" width="350px">
      <DatePickerField
        label={<GreyBlackLabel label={label} {...longAttributeStyles.labelContainerProps} {...labelProps} />}
        name={dateFieldName}
        minDate={moment().subtract(1, "days").toDate()}
        errors={errors}
        control={control}
        includeIcon={false}
        usePortal
        overrideHelperSpace
        triggerButtonProps={{
          padding: "0",
          height: "32px !important",
          paddingTop: "0 !important",
          paddingLeft: "2px !important",
          fontSize: "14px",
        }}
        formFieldProps={{
          sideLayout: true,
          labelProps: { display: "flex", alignItems: "flex-end", ...longAttributeStyles.labelContainerProps },
          overrideHelperSpace: true,
        }}
        onDateChange={(date: Date | undefined) => {
          handleDateChange(date);
        }}
        {...rest}
      />
    </Box>
  );
}
